class Logger {
  static isDebug = process.env.NODE_ENV === "development";

  static log(...args) {
    if (this.isDebug) {
      console.log(...args);
    }
  }

  static error(...args) {
    if (this.isDebug) {
      console.error(...args);
    }
  }

  static warn(...args) {
    if (this.isDebug) {
      console.warn(...args);
    }
  }

  static info(...args) {
    if (this.isDebug) {
      console.info(...args);
    }
  }
}

export default Logger;
